import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { actions as pricingTrendsActions } from '../../reducers/modules/organization/pricingTrends/pricingTrends';
import PricingTrendsDisplay from '../../components/Home/PricingTrends/PricingTrends';

class PricingTrends extends Component {
  static propTypes = {
    pricingYear: PropTypes.number,
    dispatch: PropTypes.func,
    pricingTrends: PropTypes.shape({
      loading: PropTypes.bool,
      loaded: PropTypes.bool,
      data: PropTypes.object
    })
  };

  constructor(props) {
    super(props);
  }

  componentDidMount() {
    pricingTrendsActions.getPricingTrends(this.props.dispatch, this.props.pricingYear);
  }

  render() {
    const pricingTrendsLoaded =
      this.props.pricingTrends && !this.props.pricingTrends.loading && this.props.pricingTrends.loaded;
    let pricingTrends = [];
    if (pricingTrendsLoaded) {
      pricingTrends = [
        {
          year: this.props.pricingYear - 2,
          count:
            this.props.pricingTrends.data.priorYear.jobPricingStatus.priced +
            this.props.pricingTrends.data.priorYear.jobPricingStatus.slotted
        },
        {
          year: this.props.pricingYear - 1,
          count:
            this.props.pricingTrends.data.previousYear.jobPricingStatus.priced +
            this.props.pricingTrends.data.previousYear.jobPricingStatus.slotted
        },
        {
          year: this.props.pricingYear,
          count:
            this.props.pricingTrends.data.currentYear.jobPricingStatus.priced +
            this.props.pricingTrends.data.currentYear.jobPricingStatus.slotted
        }
      ];
    }
    return <PricingTrendsDisplay pricingTrends={pricingTrends} />;
  }
}

const mapStateToProps = ({ pricingTrends }) => ({ pricingTrends });

export default connect(mapStateToProps)(PricingTrends);
